import React from 'react'
import { COMPANY_ID } from '../models/Company'

export const CompanyContext = React.createContext({
  companyId: COMPANY_ID.NATURA,
})
